import React, { Suspense } from 'react';

const DelayedPmaxLiteSignupWizardInternal = React.lazy(() => import(/* webpackMode: 'lazy' *//* webpackChunkName: "pmax-lite-signup-wizard.async" */'./pmax-lite-signup-wizard-with-i18n'));

export const DelayedPmaxLiteSignupWizard = props => (
  <Suspense fallback={<div />}>
    <DelayedPmaxLiteSignupWizardInternal {...props} />
  </Suspense>
);
